function ids(values) {
    return Array.from(new Set((Array.isArray(values) ? values : [])
        .map(Number).filter(id => Number.isSafeInteger(id) && id > 0))).sort((a, b) => a - b);
}

function normalizeCardTargets(value) {
    // Missing targets are old company-wide rules. Invalid new restrictions fail closed.
    if (value === undefined || value && value.mode === 'all') return {mode: 'all'};
    return {
        mode: 'selected',
        department_ids: ids(value && value.department_ids),
        employee_ids: ids(value && value.employee_ids)
    };
}

function cardTargetsMatch(value, employeeId, accountDepartmentIds) {
    const targets = normalizeCardTargets(value);
    return targets.mode === 'all'
        || targets.employee_ids.includes(Number(employeeId))
        || ids(accountDepartmentIds).some(id => targets.department_ids.includes(id));
}

module.exports = {normalizeCardTargets, cardTargetsMatch};
